import { EVENT_APPRAISER_ASSIGNMENT_STATUS } from '../components/shared/constants';
import { CHANGE_DATE_REQUEST_STATUS } from '../constants/ChangeDateRequestConstants';
import { EVENT_APPRAISER_ASSIGNMENT_ROLE } from '../constants/EventAppraiserAssignmentRole';

export const getCanFinalizeEvent = (eventFormData, dateRequestStatus, filteredAssignmentData) => {
  if (
    !eventFormData.atl ||
    dateRequestStatus === CHANGE_DATE_REQUEST_STATUS.PENDING_ADMIN_APPROVAL ||
    dateRequestStatus === CHANGE_DATE_REQUEST_STATUS.PENDING_FDA_APPROVAL
  ) {
    return false;
  }

  const primaryUsers = filteredAssignmentData?.filter(
    assigmnent => assigmnent.role === EVENT_APPRAISER_ASSIGNMENT_ROLE.PRIMARY
  );

  const isEveryPrimaryRoleResponse = primaryUsers?.every(
    assigmnent =>
      assigmnent.status && assigmnent.status !== EVENT_APPRAISER_ASSIGNMENT_STATUS.ASSIGNED
  );

  return isEveryPrimaryRoleResponse;
};
